import Layout from '@/framework/layout';
export default [{
    code: 'iov:part',
    path: '/part',
    name: 'part',
    alwaysShow: true,
    component: Layout,
    redirect: 'ElecDataTwin',
    meta: { title: '零部件孪生', elSvgIcon: 'Fold' },

    //
    // sany-truck-master-board
    //
    children: [

        {
            code: 'iov:electronic',
            path: '/electronic',
            name: 'electronic',
            meta: { title: '电子电气系统', cachePage: true },

            children: [{
                    code: 'iov:elecDataTwin', //
                    path: '/elecDataTwin',
                    name: 'ElecDataTwin',
                    component: () =>
                        import ('@/framework/serviceView/parts/electronic/dataTwinPage.vue'),
                    meta: { title: '数据孪生', cachePage: true }
                },
                {
                    code: 'iov:elecDataQuery',
                    path: '/elecDataQuery',
                    name: 'ElecDataQuery',
                    component: () =>
                        import ('@/framework/serviceView/parts/electronic/dataQueryPage.vue'),
                    meta: { title: '数据查询', cachePage: true }
                },
                {
                    code: 'iov:elecFaultManager',
                    path: '/elecFaultManager',
                    name: 'ElecFaultManager',
                    component: () =>
                        import ('@/framework/serviceView/parts/electronic/faultManagePage.vue'),
                    meta: { title: '故障管理', cachePage: true }
                },
                {
                    code: 'iov:elecModelManagement',
                    path: '/elecModelManagement',
                    name: 'ElecModelManagement',
                    component: () =>
                        import ('@/framework/serviceView/parts/electronic/modelManagePage.vue'),
                    meta: { title: '模型管理', cachePage: true }
                },
                {
                    code: 'iov:elecTruckManager',
                    path: '/elecTruckManage',
                    name: 'ElecTruckManage',
                    component: () =>
                        import ('@/framework/serviceView/parts/electronic/vehicleManagePage.vue'),
                    meta: { title: '车辆管理', cachePage: true }
                },
            ]

        },
        {
            code: 'iov:postProcessing',
            path: '/postProcess',
            name: 'PostProcess',
            meta: { title: '后处理', cachePage: true },

            children: [{
                    code: 'iov:postDataQuery',
                    path: '/postDataQuery',
                    name: 'PostDataQuery',
                    component: () =>
                        import ('@/framework/serviceView/parts/postProcessing/dataQueryPage.vue'),
                    meta: { title: '数据查询', cachePage: true }
                },
                {
                    code: 'iov:postFaultManager',
                    path: '/postFaultManager',
                    name: 'PostFaultManager',
                    component: () =>
                        import ('@/framework/serviceView/parts/postProcessing/faultManagePage.vue'),
                    meta: { title: '故障管理', cachePage: true }
                },
                {
                    code: 'iov:postModelManagement',
                    path: '/postModelManagement',
                    name: 'PostModelManagement',
                    component: () =>
                        import ('@/framework/serviceView/parts/postProcessing/modelManagePage.vue'),
                    meta: { title: '模型管理', cachePage: true }
                },
                {
                    code: 'iov:postTruckManager',
                    path: '/postTruckManage',
                    name: 'PostTruckManage',
                    component: () =>
                        import ('@/framework/serviceView/parts/postProcessing/vehicleManagePage.vue'),
                    meta: { title: '车辆管理', cachePage: true }
                },
            ]

        },
        {
            code: 'iov:partStorageBattery',
            path: '/partStorageBattery',
            name: 'PartStorageBattery',
            meta: { title: '蓄电池', cachePage: true },

            children: [

                {
                    code: 'iov:partsSBDataQuery',
                    path: '/partsSBDataQuery',
                    name: 'PartsSBDataQuery',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/dataQueryPage.vue'),
                    meta: { title: '数据查询', cachePage: true }
                },
                {
                    code: 'iov:partsSBFaultManager',
                    path: '/partsSBFaultManager',
                    name: 'PartsSBFaultManager',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/faultManagePage.vue'),
                    meta: { title: '故障管理', cachePage: true }
                },
                {
                    code: 'iov:partsSBModelManagement',
                    path: '/partsSBModelManagement',
                    name: 'PartsSBModelManagement',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/modelManagePage.vue'),
                    meta: { title: '模型管理', cachePage: true }
                },
                {
                    code: 'iov:partsSBTruckManager',
                    path: '/partsSBTruckManage',
                    name: 'PartsSBTruckManage',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/vehicleManagePage.vue'),
                    meta: { title: '车辆管理', cachePage: true }
                },
                {
                    code: 'iov:partsSBAlarmRecordPage',
                    path: '/partsSBAlarmRecordPage',
                    name: 'PartsSBAlarmRecordPage',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/alarmRecordPage.vue'),
                    meta: { title: '告警数据', cachePage: true }
                },
                {
                    code: 'iov:partsSBCurrentAlarmPage',
                    path: '/partsSBCurrentAlarmPage',
                    name: 'PartsSBCurrentAlarmPage',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/currentAlarmPage.vue'),
                    meta: { title: '当前告警', cachePage: true }
                },
                {
                    code: 'iov:partsSBFaultstatisticsPage',
                    path: '/partsSBFaultstatisticsPage',
                    name: 'PartsSBFaultstatisticsPage',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/faultstatisticsPage.vue'),
                    meta: { title: '故障统计', cachePage: true }
                },
                {
                    code: 'iov:partsSBHealthAnalysisPage',
                    path: '/partsSBHealthAnalysisPage',
                    name: 'PartsSBHealthAnalysisPage',
                    component: () =>
                        import ('@/framework/serviceView/parts/storageBattery/healthAnalysisPage.vue'),
                    meta: { title: '健康度分析', cachePage: true }
                },
            ]

        },
        {
            code: 'iov:partTbox',
            path: '/partTbox',
            name: 'PartTbox',
            meta: { title: 'T-box', cachePage: true },

            children: [

                {
                    code: 'iov:partTboxLogData',
                    path: '/partTboxLogData',
                    name: 'PartTboxLogData',
                    component: () =>
                        import ('@/framework/serviceView/parts/tbox/tboxLogDataPage.vue'),
                    meta: { title: '日志下载', cachePage: true }
                },
                {
                    code: 'iov:partCanLogData',
                    path: '/partCanLogData',
                    name: 'PartCanLogData',
                    component: () =>
                        import ('@/framework/serviceView/parts/tbox/canLogDataPage.vue'),
                    meta: { title: 'Can报文下载', cachePage: true }
                },
                {
                    code: 'iov:partTboxAdasis',
                    path: '/partTboxAdasis',
                    name: 'partTboxAdasis',
                    component: () =>
                        import ('@/framework/serviceView/parts/tbox/adasisDataPage.vue'),
                    meta: { title: 'adasis', cachePage: true }
                },
                {
                    code: 'iov:partTboxOfflineCount',
                    path: '/partTboxOfflineCount',
                    name: 'PartTboxOfflineCount',
                    component: () =>
                        import ('@/framework/serviceView/parts/tbox/tboxOfflineCountPage.vue'),
                    meta: { title: '离线统计', cachePage: true }
                },
                {
                    code: 'iov:tboxManage',
                    path: '/tboxManage',
                    name: 'TboxManage',
                    component: () =>
                    import ('@/framework/serviceView/parts/tbox/tboxManagePage.vue'),
                    // import ('@/framework/serviceView/parts/tbox/tboxManage/tboxSettingPage.vue'),
                    meta: { title: 'TBOX管理', cachePage: true }
                },
               
                {
                    code: 'iov:tboxModelManage',
                    path: '/tboxModelManage',
                    name: 'TboxModelManage',
                    component: () =>
                        // import ('@/framework/serviceView/parts/tbox/tboxModelManagePage.vue'),
                    import ('@/framework/serviceView/parts/tbox/tboxModelManagePage.vue'),
                    meta: { title: '型号管理', cachePage: true }
                },
                {
                    code: 'iov:tboxHighDensity',
                    path: '/tboxHighDensity',
                    name: 'TboxHighDensity',
                    component: () =>
                    import ('@/framework/serviceView/parts/tbox/highDensityConfigurationPage.vue'),
                    meta: { title: '高密采集配置', cachePage: true }
                },

                

            ]

        },
        {
            code: 'iov:partGlonass',
            path: '/partGlonass',
            name: 'PartGlonass',
            meta: { title: 'T-box', cachePage: true },

            children: [
                {
                    code: 'iov:glonassManage',
                    path: '/glonassManage',
                    name: 'GlonassManage',
                    component: () =>
                        import ('@/framework/serviceView/parts/glonass/GlonassManagePage.vue'),
                    meta: { title: 'Glonass管理', cachePage: true }
                },

            ]

        },
        {
            code: 'iov:partTravelData',
            path: '/partTravelData',
            name: 'PartTravelDatax',
            meta: { title: '行驶记录仪', cachePage: true },
            // sany-truck-master-board
            children: [

                {
                    code: 'iov:partTruckManager',
                    path: '/partTravelTruckManager',
                    name: 'partTravelTruckManager',
                    component: () =>
                        import ('@/framework/serviceView/parts/travelData/deviceManagerPage.vue'),
                    meta: { title: '设备管理', cachePage: true }
                },
                // {
                //     code: 'iov:partTravelTruckMonitor',
                //     path: '/partTravelTruckMonitor',
                //     name: 'partTravelTruckMonitor',
                //     component: () =>
                //         import ('@/framework/serviceView/parts/travelData/truckMonitorPage.vue'),
                //     meta: { title: '车辆监控', cachePage: true }
                // },
                // {
                //     code: 'iov:partTravelRawData',
                //     path: '/partTravelRawData',
                //     name: 'partTravelRawData',
                //     component: () =>
                //         import ('@/framework/serviceView/parts/travelData/rawDataPage.vue'),
                //     meta: { title: '原始数据', cachePage: true }
                // },

            ]

        },
    ]
}, ];